// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import './js/directives.js' //设置dialog拖动指令 el-dialog 加v-dialogDrag可以拖拽
import './js/copy' //设置点击复制指令， 加v-copy复制文本
import { MessageBox, Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import SkuForm from 'vue-sku-form'
import './router/permission'
// import zhLang from 'element-ui/lib/locale/lang/zh-CN'; // 引入官方的中文国际化
// import locale from './assets/cn'; // 引入自己的
import $ from 'jquery'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
// 引入Moment.js时间插件
import moment from 'moment'
Vue.prototype.$moment = moment
//import App from './App'
//import router from './router'
import Print from 'vue-print-nb'
import '@/flow/ef/index.css'
import App from './App'
import router from './router'
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(Print);  //注册
Vue.use(SkuForm)
Vue.use(dataV)

// Vue.use(ElementUI, {
//   locale: { ...zhLang, ...locale }, // 使用本地的 locale 去覆盖官方的 zhLang
// });




Vue.use(ElementUI);
const messages = ['success', 'warning', 'info', 'error'];
messages.forEach(type => {
  Vue.prototype.$message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      };
      // 默认配置
      options.duration = 1000;
      options.showClose = true;
    }
    options.type = type;
    return Vue.prototype.$message(options);
  }
})

// axios.defaults.baseURL = '/api'; //设置基址
axios.defaults.headers.post['Content-Type'] = 'application/x-www-fromurlencodeed'
axios.interceptors.request.use(config => {
  //若存在这样的token，则从本地存储取出
  if (sessionStorage.getItem('token')) {
    config.headers.Authorization = "Bearer " +  sessionStorage.getItem('token')
  }
  return config
}, error => {
  return Promise.reject(error)
});
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/',
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          MessageBox({
            message: '登录过期，请重新登录',
            duration: 1000,
            forbidClick: true
          });
          // 清除token
          sessionStorage.removeItem('token');

          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;

        // 404请求不存在
        case 404:
          MessageBox({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          MessageBox({
            message: error.response.data.message,
            duration: 1500,
            forbidClick: true
          });
      }
      return Promise.reject(error.response);
    }
  }
);





Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

//路由守卫





/* eslint-disable no-new */


// // 自定义组件
// const requireComponents = require.context('@/components', true, /\.vue/)
// // 打印结果
// requireComponents.keys().forEach(fileName => {
//   // 组件实例
//   const reqCom = requireComponents(fileName)
//   console.log(reqCom)
//   // 截取路径作为组件名
//   const reqComName =reqCom.name|| fileName.replace(/\.\/(.*)\.vue/,'$1')
//   console.log(reqComName)
//   // 组件挂载
//   Vue.component(reqComName, reqCom.default || reqCom)
// })
// import { MessageBox,Message } from 'element-ui';

// Vue.prototype.$message = function (msg) {
//   Message(msg)
// }
// Vue.prototype.$message = function(msg){
//   return Message({
//     message:msg,
//     duration:2000
//   })

// }
// Vue.prototype.$message.success = function (msg) {
//   return Message.success({
//     message: msg,
//     duration: 1500
//   })
// }
// Vue.prototype.$message.warning = function (msg) {
//   return Message.warning({
//     message: msg,
//     duration: 1000
//   })
// }




new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js